{
  "$schema": "./schema.json",
  "formFields": {
    "companyLabel": "Ditt företag",
    "companyPlaceholder": {
      "SE": "Sök bolagsnamn eller org. nr.",
      "FI": "Sök företagsnamn eller FO-nummer"
    },
    "companyErrors": {
      "orgNumberRequired": "Organisationsnummer krävs",
      "orgNumberInvalid": "Ange ett giltigt organisationsnummer",
      "orgNameRequired": "Företagsnamn krävs"
    },
    "companyFindHelp": "Hittar du inte ditt företag? Ange ditt organisationsnummer.",
    "companyPreloader": "Söker...",
    "companyChange": "Ändra",
    "companySelect": "Välj",
    "emailLabel": "E-post",
    "emailPlaceholder": {
      "SE": "kontakt@bolag.se",
      "FI": "kontakt@bolag.fi"
    },
    "emailErrors": {
      "invalid": "Ogiltig e-post",
      "required": "E-post krävs",
      "validationError": "Vänligen ange en giltig e-postadress"
    },
    "phoneLabel": "Mobilnummer",
    "phonePlaceholder": {
      "SE": "070 000 00 00",
      "FI": "050 0000 000"
    },
    "phoneErrors": {
      "invalid": "Mobilnumret är ogiltigt",
      "required": "Mobilnumret krävs"
    },
    "amountLabel": "Önskat finansieringsbelopp",
    "limitedCompanyConfirmation": "Aktiebolag",
    "requestedAmountErrors": {
      "typeError": "Använd endast siffror",
      "required": "Välj belopp"
    },
    "consentError": "Du behöver godkänna att vi behandlar dina personuppgifter för att använda tjänsten",
    "privacyPolicyConsent": "Jag godkänner att {{company}} behandlar mina <1>personuppgifter</1>",
    "minimumAmountError": "Minsta belopp att ansöka om är {{amount}}"
  }
}
